export default __webpack_public_path__ + "static/sparkle-footer-logo-mark-134ea17c6ab8373466954464cadaa38e.png";